// Centralized backend API URL for easy environment switching
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://api.giftoria.me';
//export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';